import React, { useEffect } from "react";
import CreateOutlinedIcon from "@material-ui/icons/CreateOutlined";
import { Button } from "@my-scoot/component-library-legacy";
import { useWalletStore } from "features/Account/modules/Wallets/store/WalletStore";
import { useAdminPanelStore } from "features/AdminPanel/store/useAdminPanelStore";
import {
  automatedPayoutKeys,
  FREQUENCY_KEYS,
  PAYOUT_AMOUNT_KEYS,
  WEEK_DAYS_KEYS,
} from "features/Account/modules/Wallets/constants/Wallets.constants";
import { useWalletSettings } from "../../utils/useWalletSettings";

export const PayoutAddEditDetailsButton = ({ subSectionKey }) => {
  const sectionConfig = useAdminPanelStore((state) => state.sectionConfig);
  const subSectionConfig = sectionConfig[subSectionKey] || {};
  const { value } = subSectionConfig;
  const isAutomatedPayoutModalOpen = useWalletStore(
    (state) => state.isAutomatedPayoutModalOpen
  );
  const initailizeAutomatedPayoutFormDate = useWalletStore(
    (state) => state.initailizeAutomatedPayoutFormDate
  );
  const { getPayoutHappenString, getInitialPayoutType } = useWalletSettings();

  useEffect(() => {
    initailizeAutomatedPayoutFormDate({
      [automatedPayoutKeys.payoutType]: getInitialPayoutType({
        payoutConfig: value,
      }),
      [automatedPayoutKeys.payoutAmount]: value?.[
        automatedPayoutKeys.customSettlementAmount
      ]
        ? PAYOUT_AMOUNT_KEYS.custom
        : PAYOUT_AMOUNT_KEYS.full,
      [automatedPayoutKeys.weeklyPayoutDay]: value?.[
        automatedPayoutKeys.weeklyPayoutDay
      ]
        ? value?.[automatedPayoutKeys.weeklyPayoutDay]
        : WEEK_DAYS_KEYS.monday,
      [automatedPayoutKeys.monthlyPayoutDay]:
        value?.[automatedPayoutKeys.monthlyPayoutDay],
      [automatedPayoutKeys.customCycleDays]:
        value?.[automatedPayoutKeys.customCycleDays],
      [automatedPayoutKeys.customSettlementAmount]:
        value?.[automatedPayoutKeys.customSettlementAmount],
    });
  }, []);

  const condtionalStyles = {
    shouldOffsetMainContainer:
      !value?.[automatedPayoutKeys.customSettlementAmount] &&
      (value?.[automatedPayoutKeys.payoutType] === FREQUENCY_KEYS.weekly ||
        value?.[automatedPayoutKeys.payoutType] === FREQUENCY_KEYS.monthly),
    shouldOffsetMainContainerForCustomDays:
      !value?.[automatedPayoutKeys.customSettlementAmount] &&
      value?.[automatedPayoutKeys.payoutType] === FREQUENCY_KEYS.custom,
    shouldConstrainPayoutWidth:
      !value?.[automatedPayoutKeys.customSettlementAmount] &&
      value?.[automatedPayoutKeys.payoutType] !== FREQUENCY_KEYS.daily,
  };

  return value?.[automatedPayoutKeys.isAutomated] &&
    value?.[automatedPayoutKeys.payoutType] ? (
    <div
      className={`tw-grid ${
        condtionalStyles.shouldOffsetMainContainer && "tw-ml-[72px]"
      } ${
        condtionalStyles.shouldOffsetMainContainerForCustomDays &&
        "tw-ml-[25px]"
      }`}
    >
      <div
        className={`tw-text-[14px] tw-bg-[#F4F4F4] tw-rounded-[5px] tw-p-[10px_12px] ${
          condtionalStyles.shouldConstrainPayoutWidth && "tw-w-[80%]"
        }`}
      >
        <span>Withdrawal will happen: </span>
        <span className="tw-font-medium">{getPayoutHappenString(value)}</span>
      </div>
      <Button
        color="link"
        size="small"
        className="!tw-h-[32px] !tw-p-0 !tw-mt-[12px]"
        onClick={() => {
          isAutomatedPayoutModalOpen(true);
        }}
      >
        <CreateOutlinedIcon className="!tw-w-[18px] !tw-h-[18px]" />
        <span className="tw-ml-[4px] !tw-text-[14px] !tw-font-medium">
          Edit details
        </span>
      </Button>
    </div>
  ) : (
    <Button
      color="secondary"
      variant="outlined"
      size="small"
      className="!tw-px-[14px] !tw-h-[32px]"
      onClick={() => {
        isAutomatedPayoutModalOpen(true);
      }}
    >
      <CreateOutlinedIcon className="!tw-w-[18px] !tw-h-[18px]" />
      <span className="tw-ml-[4px] !tw-text-[14px] !tw-font-medium">
        Add details
      </span>
    </Button>
  );
};
